<template>
  <v-dialog v-model="visible" max-width="480" persistent>
    <v-card>
      <v-card-title>Simular onValidate</v-card-title>
      <v-card-text>
        <p class="text-caption text-medium-emphasis mb-4">
          La GUI está esperando la validación de identidad. Elegí con qué responder;
          el éxito devuelve los tokens de esta misma configuración.
        </p>
        <v-select
          v-model="selectedIndex"
          :items="optionItems"
          item-title="label"
          item-value="index"
          label="Respuesta"
          density="compact"
          hide-details
        ></v-select>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" variant="flat" @click="respond">Responder</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// Puerto de la simulación de onValidate de alison-gui/index.html: a
// diferencia de VerifyIdentityDialog.vue (que simula la UX completa de
// verificación de identidad de un host real), esta lista está pensada para
// ejercitar puntualmente los códigos de error que AlisonGUI ya sabe pintar
// (ver utils/errorHints.js y components/Constants.js del lado de alison-gui),
// sin tener que provocarlos de verdad. El éxito NO llama a ningún backend:
// devuelve los tokens que ya estaban en la config montada.
const VALIDATION_SIM_OPTIONS = [
  { kind: 'success', label: 'Éxito — responde con los tokens configurados' },
  // El host no rechaza esto cuando el usuario abandona la validación de su
  // lado — simplemente nunca resuelve la promesa (no hay señal que mandar).
  // Por eso "cancel" no resuelve ni rechaza: sólo cierra el diálogo y deja
  // la promesa de onValidate colgada, igual que en el caso real.
  { kind: 'cancel', label: 'Cancelar — el usuario abandona la validación (no resuelve la promesa)' },
  { kind: 'error', code: 20409, label: 'Token JWT no definido (20409)', description: 'El token JWT necesario para acceder no está definido' },
  { kind: 'error', code: 20413, label: 'Acceso no autorizado a Alison Cloud (20413)', description: 'Acceso no autorizado' },
  { kind: 'error', code: 23501, label: 'Token no autorizado para el certificado (23501)', description: 'Su token JWT no está autorizado para este certificado' },
  { kind: 'error', code: 20408, label: 'Alison Cloud no accesible (20408)', description: 'Alison Cloud no pudo ser accedido' },
  { kind: 'error', code: 20422, label: 'Firma Remota Argentina no accesible (20422)', description: 'Firma Remota Argentina no pudo ser accedida' },
  { kind: 'error', code: 23251, label: 'Servidor de certificados inaccesible (23251)', description: 'Servidor de Certificados inaccesible' },
  { kind: 'error', code: undefined, label: 'Error genérico (sin código)', description: 'Error simulado de validación de identidad' },
];

export default {
  name: 'GuiPlaygroundValidateDialog',
  data: () => ({
    visible: false,
    selectedIndex: 0,
    tokens: null,
    resolveFn: null,
    rejectFn: null,
    optionItems: VALIDATION_SIM_OPTIONS.map((opt, index) => ({ ...opt, index })),
  }),
  methods: {
    // Llamado desde providers.server/tad.onValidate (ver attachValidateSimulation
    // en GuiPlayground.vue). Devuelve la misma Promise que la GUI espera de vuelta.
    open(tokens) {
      this.tokens = tokens;
      this.selectedIndex = 0;
      this.visible = true;
      return new Promise((resolve, reject) => {
        this.resolveFn = resolve;
        this.rejectFn = reject;
      });
    },
    respond() {
      const chosen = VALIDATION_SIM_OPTIONS[this.selectedIndex];
      const { resolveFn: resolve, rejectFn: reject, tokens } = this;
      this.visible = false;
      this.resolveFn = null;
      this.rejectFn = null;
      this.tokens = null;

      if (chosen.kind === 'success') {
        this.$emit('result', `onValidate simulado: éxito — ${JSON.stringify(tokens)}`);
        resolve?.(tokens);
        return;
      }
      if (chosen.kind === 'cancel') {
        this.$emit('result', 'onValidate simulado: cancelado — la promesa queda sin resolver, la GUI no debería cambiar');
        return;
      }
      const error = new Error(chosen.description);
      // La GUI lee `code` y `detail`/`description` del error (ver
      // AlisonModal#runStartValidation y ModalMessage en alison-gui).
      if (chosen.code !== undefined) error.code = chosen.code;
      error.description = chosen.description;
      error.detail = chosen.description;
      this.$emit('result', `onValidate simulado: error — ${chosen.label}`);
      reject?.(error);
    },
  },
};
</script>
